import { createCommonStore } from '.';

export interface HeaderStore {
  isMobileMenuVisible: boolean;
  setIsMobileMenuVisible: (isVisible: boolean) => void;

  isUserDropdownVisible: boolean;
  setIsUserDropdownVisible: (isVisible: boolean) => void;

  isLocaleDropdownVisible: boolean;
  setIsLocaleDropdownVisible: (isVisible: boolean) => void;

  isSearchInputVisible: boolean;
  setIsSearchInputVisible: (isVisible: boolean) => void;
}

export const useHeaderStore = createCommonStore<HeaderStore>((set) => ({
  isMobileMenuVisible: false,
  setIsMobileMenuVisible: (isVisible) => set({ isMobileMenuVisible: isVisible }),
  isUserDropdownVisible: false,
  setIsUserDropdownVisible: (isVisible) => set({ isUserDropdownVisible: isVisible }),
  isLocaleDropdownVisible: false,
  setIsLocaleDropdownVisible: (isVisible) => set({ isLocaleDropdownVisible: isVisible }),
  isSearchInputVisible: false,
  setIsSearchInputVisible: (isVisible) => set({ isSearchInputVisible: isVisible }),
}));
